import React, { Component } from 'react';

class PopupImage extends Component {
  constructor(props) {
    super(props);
    // Initial state to track if the popup is open
    this.state = {
      isOpen: false,
    };
  }

  // Method to open the popup
  openPopup = () => {
    this.setState({ isOpen: true });
  };

  // Method to close the popup
  closePopup = () => {
    this.setState({ isOpen: false });
  };

  render() {
    const { imageUrl, thumbnailUrl } = this.props;
    const { isOpen } = this.state;
    return (
      <div>
        {/* Thumbnail or smaller version of the image */}
        <img
          src={thumbnailUrl}
          alt="Thumbnail"
          onClick={this.openPopup}
          style={{cursor: 'pointer', 
            maxWidth: '100%', 
            maxHeight: '250px',
            textAlign: 'center', 
            // height: 'auto',
            border: '1px solid #ddd',
            borderRadius: '5px',
            display: 'block',
            // margin: '0px auto'
            marginTop: '-15px'
            }}
          // style={{  width: '300px', height: '300px' }}
          // style={{cursor: 'pointer', aspectRatio: 9 / 16,  width: '100%', height: '300px'}}
        /> 

        {/* Conditional rendering of the popup */}
        {isOpen && (
          <div className="popup-overlay" onClick={this.closePopup}>
            <div className="popup-content">
              <img src={imageUrl} alt="Popup" className="popup-image" style={{width: '800px', height: '100%'}} />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default PopupImage;
